<template>
  <layout-content-horizontal-nav :nav-menu-items="$store.state.app.menu">
    <!-- Default Slot -->
    <slot></slot>

    <!-- Navbar -->
    <template #navbar>
      <div
        class="navbar-content-container"
        :class="{'expanded-search': shallShowFullSearch}"
      >
        <!-- Left Content: Search -->
        <div class="d-flex align-center">
          <div class='mx-10'>
            <span class="font-weight-bold" style="font-size: 18px;color: #673ab7">Chatbot</span>
          </div>
        </div>

<!--        <div style="position: absolute;left: 35%" class="d-flex">-->
<!--          <router-link-->
<!--            to="/bookManagement"-->
<!--            class="d-flex align-center text-decoration-none"-->
<!--          >-->
<!--            <div style="font-size: 18px"><h2 :class="$route.path === '/bookManagement'? 'app-title': 'app-title text&#45;&#45;primary'">-->
<!--              Chatbot-->
<!--            </h2></div>-->
<!--          </router-link>-->
<!--        </div>-->

        <!-- Right Content: I18n, Light/Dark, Notification & User Dropdown -->
        <div class="d-flex align-center">
          <!-- <div class="mr-10">Hi <span class="font-weight-bold ml-2" style="font-size: 16px">{{ Storang.get('username') }}</span></div> -->
          <app-bar-theme-switcher></app-bar-theme-switcher>
<!--          <app-bar-user-menu class="ms-2"></app-bar-user-menu>-->
        </div>
      </div>
<!--      <v-overlay-->
<!--        :value="$store.state.app.shallContentShowOverlay"-->
<!--        z-index="5"-->
<!--        absolute-->
<!--        class="system-bar-overlay"-->
<!--      ></v-overlay>-->
    </template>

    <!-- Slot: footer -->
    <template #footer>
      <div class="d-flex justify-center" style="font-size: 12px">
        Copyright 2001-{{ new Date().getFullYear() }} © Accenture.All rights reserved.Accenture Confidential.For
        internal use only.
      </div>
    </template>

    <!-- App Content -->
<!--    <template #v-app-content>-->
<!--      <app-customizer class="d-none d-md-block"></app-customizer>-->
<!--    </template>-->
  </layout-content-horizontal-nav>
</template>

<script>

import LayoutContentHorizontalNav from '@core/layouts/variants/content/horizontal-nav/LayoutContentHorizontalNav.vue'
import AppCustomizer from '@core/layouts/components/app-customizer/AppCustomizer.vue'


// App Bar Components
import AppBarSearch from '@core/layouts/components/app-bar/AppBarSearch.vue'
import AppBarThemeSwitcher from '@core/layouts/components/app-bar/AppBarThemeSwitcher.vue'
import AppBarUserMenu from '@/components/AppBarUserMenu.vue'

// Search Data
import appBarSearchData from '@/assets/app-bar-search-data'

import { ref, watch} from '@vue/composition-api'

import {settings} from '@/myops/core'
import { mdiHeartOutline } from '@mdi/js'

export default {
  components: {
    LayoutContentHorizontalNav,
    AppCustomizer,

    // App Bar Components
    AppBarSearch,
    AppBarThemeSwitcher,
    AppBarUserMenu,
  },
  setup() {
    // Search
    const appBarSearchQuery = ref('')
    const shallShowFullSearch = ref(false)
    const maxItemsInGroup = 5
    const totalItemsInGroup = ref({
      pages: 0,
      files: 0,
      contacts: 0,
    })
    watch(appBarSearchQuery, () => {
      totalItemsInGroup.value = {
        pages: 0,
        files: 0,
        contacts: 0,
      }
    })

    const searchFilterFunc = (item, queryText, itemText) => {
      if (item.header || item.divider) return true

      const itemGroup = (() => {
        if (item.to !== undefined) return 'pages'
        if (item.size !== undefined) return 'files'
        if (item.email !== undefined) return 'contacts'

        return null
      })()

      const isMatched = itemText.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1

      if (isMatched) {
        if (itemGroup === 'pages') totalItemsInGroup.value.pages += 1
        else if (itemGroup === 'files') totalItemsInGroup.value.files += 1
        else if (itemGroup === 'contacts') totalItemsInGroup.value.contacts += 1
      }

      return appBarSearchQuery.value && isMatched && totalItemsInGroup.value[itemGroup] <= maxItemsInGroup
    }

    return {
      // Search
      appBarSearchQuery,
      shallShowFullSearch,
      appBarSearchData,
      searchFilterFunc,
      // Storang,
      // App Config
      appName: settings.themeConfig.app.name,
      appLogo: settings.themeConfig.app.logo,

      // Icons
      icons: {
        mdiHeartOutline,
      },
    }
  },
}
</script>

<style lang="scss" scoped>
.app-title {
  font-size: 1rem;
  font-weight: 600;
}

.navbar-content-container {
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-grow: 1;
  position: relative;
}
</style>
